export default function () {
	return `
	<span ${this.html.classAttr(['field__sortableHandle'])} ${this.html.dataAttr({sortableHandle: true})}>
		${this.html.svgIcon('drag-vertical')}
	</span>
	`;
}
